let currentGoogleId = null;

export function initGoogleAds(id) {
  if (!id) return;

  // 已经初始化过同一个 ID
  if (window.gtag && currentGoogleId === id) {
    return;
  }

  // 第一次初始化
  if (!window.gtag) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    window.gtag("js", new Date());
  }

  // 配置当前 ID
  window.gtag("config", id);

  currentGoogleId = id;
}
